import { isEmpty } from 'lodash'

import { logoBlue } from '../assets/logoBlue64'

import { getBaseURL } from 'service/env'

import {
  WIDTH as WIDTHPdf,
  HEIGHT as HEIGHTPdf,
  fontSize,
  PADDING as PADDINGpdf,
} from '../constants'

import { ratio } from '../helpers'

import helpers from 'helpers'

import palette from 'theme/palette'

const firstCover = ({
  pdf,
  companyName,
  document,
  date,
  customStyles,
  customLogo,
  reportName,
  pathQrCode = '',
}) => {
  const WIDTH = WIDTHPdf(pdf)
  const HEIGHT = HEIGHTPdf(pdf)

  const documentFormatted = helpers.formatters.document.identify(document)

  pdf.setFillColor(customStyles?.main)
  pdf.rect(0, 0, WIDTH, HEIGHT, 'F')

  var PADDING = PADDINGpdf

  if (customLogo) {
    pdf.addImage(
      customLogo,
      'png',
      PADDING,
      PADDING - 10,
      ratio(500),
      ratio(158),
    )
  }

  pdf.setFontSize(fontSize.documentTitle)
  pdf.setLineHeightFactor(1.2)
  pdf.setFont('Raleway-Bold')
  var splitted_title = pdf.splitTextToSize(reportName, ratio(1700))
  pdf.setTextColor(customStyles?.textPrimary)
  pdf.text(splitted_title, PADDING, ratio(600), { align: 'left' })

  pdf.setFontSize(fontSize.subtitle)
  pdf.setFont('Raleway-Regular')
  var splitted_name = pdf.splitTextToSize(companyName, WIDTH - PADDING * 3)

  pdf.text(splitted_name, PADDING, ratio(1940))
  pdf.text(documentFormatted, PADDING, ratio(2000 + 50 * splitted_name.length))
  pdf.rect(PADDING, HEIGHT - ratio(374), WIDTH - PADDING * 2, ratio(8), 'F')
  pdf.text(date, WIDTH / 2, HEIGHT - PADDING, { align: 'center' })

  if (customStyles.main === palette.layout.main) {
    pdf.addPage()

    pdf.setFillColor(palette.white)
    pdf.rect(0, 0, WIDTH, HEIGHT, 'F')

    pdf.addImage(
      logoBlue,
      'png',
      WIDTH / 2 - PADDING * 1.25,
      PADDING - 10,
      ratio(500),
      ratio(158),
    )
    pdf.setFontSize(fontSize.documentTitle)
    pdf.setLineHeightFactor(1.2)
    pdf.setFont('Raleway-Bold')
    splitted_title = pdf.splitTextToSize(reportName, ratio(1700))
    pdf.setTextColor(palette.subscription.primary.main)
    pdf.text(splitted_title, WIDTH / 2, ratio(600), { align: 'center' })

    pdf.setFont('Raleway-Regular')

    pdf.setFontSize(fontSize.subtitle)

    splitted_name = pdf.splitTextToSize(companyName, ratio(1024))

    pdf.text(splitted_name, WIDTH / 2, ratio(1940), { align: 'center' })
    pdf.text(
      documentFormatted,
      WIDTH / 2,
      ratio(2000 + 50 * splitted_name.length),
      {
        align: 'center',
      },
    )
    pdf.text(date, WIDTH / 2, HEIGHT - PADDING, { align: 'center' })

    if (!isEmpty(pathQrCode)) {
      pdf.setFontSize(fontSize.paragraph)

      pdf.text(
        'Verifique a autenticidade deste documento',
        WIDTH / 2,
        HEIGHT / 2,
        {
          align: 'center',
        },
      )

      const qrCode = `${getBaseURL('dponet')}/${pathQrCode}`

      pdf.addImage(
        qrCode,
        'png',
        WIDTH / 2 - 40,
        HEIGHT / 2 + 5,
        ratio(380),
        ratio(380),
      )
    }
  }
}

export default firstCover
